import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { AbsolutelyCentered } from '../../components/absolutely-centered';
import { ColorPalette } from '../../components/config/color-palette';
import { TypographySettings } from '../../components/config/typography-settings';
import { DefaultLayout } from '../../components/layout/default-layout';
import { TabContent } from '../../components/tab-content';
import { useMetaTitle } from '../../hooks';

const useStyles = makeStyles()(() => ({
  wrapper: {
    flexDirection: 'column',
    zIndex: -1,
  },
  header: {
    color: ColorPalette.DeepGalaxy,
    fontFamily: TypographySettings.AlternativeFontFamily,
    fontSize: '4rem',
    fontWeight: 300,
    lineHeight: 1.1,
    margin: 0,
  },
  content: {
    fontFamily: TypographySettings.AlternativeFontFamily,
    fontSize: '1rem',
    margin: 0,
  },
}));

export function CitizenNotFoundPage() {
  const { classes } = useStyles();
  useMetaTitle('Borgeren findes ikke');

  return (
    <DefaultLayout>
      <TabContent>
        <AbsolutelyCentered className={classes.wrapper}>
          <h1 data-testid="citizen-not-found-header" className={classes.header}>
            Borgeren findes ikke
          </h1>
          <p className={classes.content}>Den borger, du forsøgte at tilgå, kunne ikke findes. Tjek venligst linket eller søg efter borgeren igen.</p>
        </AbsolutelyCentered>
      </TabContent>
    </DefaultLayout>
  );
}
